
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/contact",
      function () {
        return require("private-next-pages/info/contact/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/contact"])
      });
    }
  